export default __webpack_public_path__ + "static/media/appleStoreButton.9ee204f4.svg";